import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useLandingSettings } from '../useLandingSettings';

export const Hero: React.FC = () => {
  const { hero, caption } = useLandingSettings();
  const navigate = useNavigate();
  const hasCaption = Boolean(caption?.trim());
  const hasHero = Boolean(hero?.trim());

  return (
    <section className="px-4 md:px-8">
      <div className="mx-auto max-w-[1180px] md:hidden">
        {hasCaption && (
          <h1
            className="hero-landing-text mx-auto max-w-[690px] text-center text-[clamp(2.125rem,9.4vw,4.25rem)] font-normal leading-[1.18] text-black [&_p]:m-0"
            dangerouslySetInnerHTML={{ __html: caption }}
          />
        )}

        <div className="relative mt-12 aspect-[1/1] overflow-hidden rounded-[28px] bg-[#f5eee2]">
          {hasHero && (
            <img
              src={hero}
              alt=""
              className="h-full w-full object-cover object-[58%_center]"
            />
          )}
          <button
            type="button"
            onClick={() => navigate('/form')}
            className="absolute bottom-[22%] left-1/2 flex h-16 w-[63%] max-w-[430px] -translate-x-1/2 items-center justify-center rounded-full bg-[#FFFDF5] px-6 text-[clamp(2rem,8vw,3rem)] font-normal leading-none text-black shadow-[0_8px_24px_rgba(0,0,0,0.08)]"
          >
            Get a quote
          </button>
        </div>
      </div>

      <div className="relative mx-auto hidden min-h-[540px] max-w-[1180px] items-center overflow-hidden rounded-[28px] bg-[#f5eee2] md:flex">
        {hasHero && (
          <>
            <img
              src={hero}
              alt=""
              className="absolute inset-0 h-full w-full object-cover object-[62%_center]"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/45 to-transparent" />
          </>
        )}

        <div className="relative z-10 max-w-[560px] px-7 py-10 md:px-14">
          {hasCaption && (
            <div
              className={`hero-landing-text text-[2rem] font-['Inter'] font-light leading-[1.12] tracking-tight md:text-[clamp(3rem,8vw,58px)] [&_p]:m-0 ${
                hasHero ? 'text-white' : 'text-[#23262C]'
              }`}
              dangerouslySetInnerHTML={{ __html: caption }}
            />
          )}
          <button
            type="button"
            onClick={() => navigate('/form')}
            className="mt-8 inline-flex h-[50px] items-center justify-center rounded-full bg-[#FFFDF5] px-12 text-2xl font-normal text-black shadow-[0_8px_24px_rgba(0,0,0,0.08)] transition-opacity hover:opacity-90"
          >
            Get a quote
          </button>
        </div>
      </div>
    </section>
  );
};
